var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex justify-content-center spinner",class:{ 'spinner--full-screen': _vm.fullScreen }},[_c('div',{staticClass:"spinner-border m-5",class:{ [`text-${_vm.colour}`]: _vm.colour },attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }